module.exports = __webpack_public_path__ + "img/icon_new_red.6f5d4fa0.svg";